module.exports = __webpack_public_path__ + "img/Waldolf_School.edbe586c.jpg";